import "./sass/style.scss";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);


$(function(){
  $(function () {
    $(".js_inview_scaleUp").on("inview", function () {
      $(this).addClass("is_fired");
    });
  });

  $(".un_new2024Firstview_show_close").click(function () {
    $(".un_new2024Firstview_show").fadeOut("500");
  });

  /* MVのブラックフェードアウトと同期させるため、オートプレイはしないで実行 */
  $('.un_new2024Firstview_visual_slider').on('init', function(){
    $('.slick-slide[data-slick-index="0"]').addClass('zooming');
  })
  $('.un_new2024Firstview_visual_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 5000,
    speed: 2000,
    pauseOnHover: false,
    infinite: true,
    arrows: false,
    dots: false,
    fade: true
  })
    .on({
      beforeChange: function(event, slick, currentSlide, nextSlide) {
        $(".slick-slide", this).eq(currentSlide).addClass("preve-slide");
        $(".slick-slide", this).eq(nextSlide).addClass("zooming");
      },
      afterChange: function() {
        $(".preve-slide", this).removeClass("preve-slide zooming");
      }
  });
  

  $('.un_new2024Tuguca_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    infinite: true,
    arrows: false,
    dots: false,
    fade: true
  });

  $('.un_new2024Rigelpro_item_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 1000,
    arrows: false,
    dots: true,
    fade: true
  });

  $('.un_new2024Connectiontable_item_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 1000,
    arrows: false,
    dots: true,
    fade: true
  });

  $('.un_new2024TakibiSandSkillet_item_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 1000,
    arrows: false,
    dots: true,
    fade: true
  });

  $('.un_new2024Sayou_item_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 1000,
    arrows: false,
    dots: true,
    fade: true
  });

  $('.un_new2024AlphaBreeze_item_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 1000,
    arrows: false,
    dots: true,
    fade: true
  });

  // 元のファーストビューslick
  /*
  $('.un_new2024Show_firstview_slider').on('init', function(){
    $('.slick-slide[data-slick-index="0"]').addClass('moving');
  })
  .slick({
    pauseOnFocus: false,
    pauseOnHover: false,
    infinite:true,
    autoplay:true,
    autoplaySpeed:4000,
    speed: 2000,
    arrows:false,
    fade:true,
  })
    .on({
      beforeChange: function(event, slick, currentSlide, nextSlide) {
        $(".slick-slide", this).eq(currentSlide).addClass("preve-slide");
        $(".slick-slide", this).eq(nextSlide).addClass("moving");
      },
      afterChange: function() {
        $(".preve-slide", this).removeClass("preve-slide moving");
      }
    });
  */
  // spw faq click
  if( $('.eventFaq').length ) {
    $('.eventFaq li p:first-child').on('click',function(){
      $(this).next().slideToggle();
    });
  }
  // inview
  // フェードイン
  $('.inviewfadeIn').on('inview', function(event, isInView, visiblePartX, visiblePartY) {
    if (isInView) {
      $(this).stop().addClass('fadeIn');
    } else {
      //$(this).stop().removeClass('fadeIn');
    }
  });

});


// ファーストビューのスライドをランダム化してslick
$(document).ready(function () {
  // スライダー要素を取得
  const slider = document.querySelector('.un_new2024Show_firstview_slider');

  // ランダム並び替え処理
  if (slider) {
    const slides = Array.from(slider.querySelectorAll(':scope > .un_new2024Show_firstview_slide'));
    const shuffledSlides = slides.sort(() => Math.random() - 0.5);

    // ランダム並び替え後の結果をコンソールに出力
    /*
    console.log("ランダム化後の順序:");
    shuffledSlides.forEach((slide, index) => {
      console.log(`スライド ${index + 1}:`, slide.outerHTML);
    });
    */

    // ランダムに並び替えた順で親要素に追加し直す
    shuffledSlides.forEach((slide) => slider.appendChild(slide));
  }

  // Slickの初期化
  $('.un_new2024Show_firstview_slider')
    .on('init', function () {
      $('.slick-slide[data-slick-index="0"]').addClass('moving');
    })
    .slick({
      pauseOnFocus: false,
      pauseOnHover: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 4000,
      speed: 2000,
      arrows: false,
      fade: true,
    })
    .on({
      beforeChange: function (event, slick, currentSlide, nextSlide) {
        $(".slick-slide", this).eq(currentSlide).addClass("preve-slide");
        $(".slick-slide", this).eq(nextSlide).addClass("moving");
      },
      afterChange: function () {
        $(".preve-slide", this).removeClass("preve-slide moving");
      },
    });
});


/* ----------------------------------
ローディング
---------------------------------- */

const loading = document.getElementById('loading');
/* 読み込み完了 */
window.addEventListener('load', stopload);

/* 10秒経ったら強制的にロード画面を非表示にする */
setTimeout(function() {
  if (loading && !loading.classList.contains('is-loaded')) {
    stopload();
  }
}, 10000);

/* ロード画面を非表示にする処理 */
function stopload(){
  loading.classList.add('is-loaded');

  /* メインビジュアルフェード処理開始（CSS連動、1.7秒後 #loading.is-loaded） */
  setTimeout(function() {
    $('.un_new2024Firstview_visual_slider').slick('slickPlay');
  }, 3700); // 1700ミリ秒 = 1.7秒

  /* スクロール連動拡大 */
  document.querySelectorAll(".un_new2024ScaleUp").forEach((el) => {
    gsap.to(el, {
      scale: 1,
      scrollTrigger: {
        trigger: el,//アニメーションが始まるトリガーとなる要素
        start: 'top bottom', //アニメーションが始まる位置
        end: 'bottom bottom', //アニメーションが終わる位置
        scrub: true, //スクロール量に合わせてアニメーションが進む（数字も指定できる）
        // markers: true,
      }
    });
  });

}

/* ----------------------------------
スムーススクロール
---------------------------------- */
document.addEventListener("click", e => {
  const target = e.target;
  // clickした要素がclass属性、smooth-scrollを含まない場合は処理を中断
  if (!target.classList.contains("smoothscroll")) return;
  e.preventDefault();
  const targetId = target.hash;
  const targetElement = document.querySelector(targetId);
  // 画面上部から要素までの距離
  const rectTop = targetElement.getBoundingClientRect().top;
  // 現在のスクロール距離
  const offsetTop = window.pageYOffset;
  // スクロール位置に持たせるバッファ
  const buffer = 100;
  const top = rectTop + offsetTop - buffer;

  window.scrollTo({
    top,
    behavior: "smooth"
  });
});

/* ----------------------------------
ヘッダー動作
---------------------------------- */
const header = document.querySelector('.ly_header');
if(document.querySelector('.un_new2024Firstview') ) {
  const headHiddenOptions = {
    root: null, // 今回はビューポートをルート要素とする
    rootMargin: "", // ビューポートの中心を判定基準にする
    threshold: 0 // 閾値は0
  };
  const fvObserver = new IntersectionObserver(doHidden, headHiddenOptions);
  fvObserver.observe(document.querySelector('.un_new2024Firstview'));
  function doHidden(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        header.classList.add('in-firstview');
      }else{
        header.classList.remove('in-firstview');
      }
    });
  }
}

// 店舗リスト一覧
$(function(){
  if( $('.js_storeList').length ) {
    $('.js_storeList').on('click',function(){
      $(this).next().slideToggle();
    });
  }
});

// 新規獲得CPボタン表示（ログアウト時のみ表示）
$(function(){
  if ($.cookie('ecLoggedIn') != "true") {
    // ログインしていなかった場合
    $("#js_newRegist").show();
  }
});

// adobe fonts 初期化
(function(d) {
	var config = {
		kitId: 'zkg3ton',
		scriptTimeout: 3000,
		async: true
	},
	h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
})(document);